var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xED\x9C\xB4\xEB\x8C\x80\xED\x8F\xB0\xEC\xA0\x9C\xEC\xB6\x9CNEW/\xEC\x88\x98\xEB\x8A\xA5\xEC\x84\xA0\xEB\xB0\xB0\xEB\xA7\x88\xED\x81\xAC"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#F3F4F6",
    stroke: "#1D1D1F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9027 10.2386V8.72078L13.2389 5.27051L7.18864 8.71375L18.8746 16.4189L18.9027 16.3697V14.8835L12.1005 10.4002L13.1511 9.78186L18.9027 13.3867V11.8548L13.1722 8.26753L10.8954 9.60618L9.66567 8.79456L13.2143 6.77429L18.9027 10.2386Z",
    fill: "#1D1D1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.02708 9.79235V11.2751L13.8292 15.7618L12.7787 16.3802L7.02708 12.7753V14.3072L12.7576 17.8945L15.0344 16.5559L16.2641 17.3675L12.7155 19.3878L7.02708 15.9234V17.4413L12.6944 20.8915L18.7411 17.4483L7.05871 9.74316L7.02708 9.79235Z",
    fill: "#1D1D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCircleLogo);
export default __webpack_public_path__ + "static/media/daily_circle_logo.dab92e88d592c6a14f8e02763ea470b6.svg";
export { ForwardRef as ReactComponent };